export const sortFieldGenerator = (field: string, isDescending: boolean) => {
  if (!field.includes(",")) {
    return `${field}${isDescending ? ":desc" : ""}`;
  } else {
    let fieldArray = field.split(",");
    return fieldArray
      .map(function (field) {
        return `${field}${isDescending ? ":desc" : ""}`;
      })
      .join(",");
  }
};
